// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editStack {
    display: none;
    position: absolute;
    right: 0px;
    bottom: 0px;
}

    .editStack > button {
        color: lightgray;
    }

    .outerStack:hover > .editStack {
        display: initial;
    }

.outerStack {
    overflow:hidden !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/controls/objectviewer/objectviewer.control.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;IAEI;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;AAEJ;IACI,0BAA0B;AAC9B","sourcesContent":[".editStack {\n    display: none;\n    position: absolute;\n    right: 0px;\n    bottom: 0px;\n}\n\n    .editStack > button {\n        color: lightgray;\n    }\n\n    .outerStack:hover > .editStack {\n        display: initial;\n    }\n\n.outerStack {\n    overflow:hidden !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
